import useSWR from 'swr'

// libs
import { apiGetService, apiHandleError } from '@/lib'

// types
import { SWRKeys, SWRFetcherData } from './types'

const getUnlock = async ({
  data: { unlockId },
}: SWRFetcherData<{ unlockId: string }>) => {
  // get api service
  const api = apiGetService()

  try {
    // retrieve unlock
    const { unlock } = await api.unlockApi.getUnlock(unlockId)

    // return payload
    return { unlock, error: '' }
  } catch (err: any) {
    const { message } = await apiHandleError(err)

    // return payload
    return { unlock: undefined, error: message }
  }
}

const fetcher = (args: SWRFetcherData<{ unlockId: string }>) => getUnlock(args)

export const useUnlock = (unlockId: string) => {
  const shouldFetch = !!unlockId

  const { data, isLoading, mutate } = useSWR(
    shouldFetch ? { key: SWRKeys.UseUnlock, data: { unlockId } } : null,
    fetcher,
    { revalidateOnFocus: false },
  )

  return {
    unlock: data?.unlock,
    isLoading,
    isError: data?.error,
    mutate,
  }
}
